
export enum TipoAutenticacao {
    CLIENTE = 'CLIENTE',
    COLABORADOR = 'COLABORADOR',
    PARCEIRO = 'PARCEIRO',
    AUTOMATICO_APP = 'AUTOMATICOAPP',
    AUTOMATICO = 'AUTOMATICO',
    CAMPANHA = 'CAMPANHA',
}
